export default __webpack_public_path__ + "static/icon-quick-drying-27217ed6c8d3cd37ab42e058f9fd04f8.webp";